import axios from "../axiosPlugin.js";

export const getDepartment = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/group/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getCommercialType = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/commercialType/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getSalesGroup = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/salesGroup/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const createCommercialType = (data, loading = true) => {
  return axios({
    url: "/api/commercialType/create",
    method: "post",
    data: {
      data,
      loading,
    },
  });
};

export const deleteCommercialType = (data, loading = true) => {
  return axios({
    url: "/api/commercialType/delete/" + data.id,
    method: "delete",
    data: {
      data,
      loading,
    },
  });
};

export const updateCommercialType = (data, loading = true) => {
  return axios({
    url: "/api/commercialType/update",
    method: "put",
    data: {
      data,
      loading,
    },
  });
};

export const updateInventory = (data, loading = true) => {
  return axios({
    url: "/api/commercialType/updateInventory?" + data,
    method: "post",
    data: {
      // data,
      loading,
    },
  });
};

export const approveCommercialType = data => {
  return axios({
    url: `/api/commercialType/approve?cinemaId=${data.cinemaId}`,
    method: "post",
    data: {
      data,
    },
  });
};

export const inventoryExport = data => {
  let queryString = `cinemaId=${data.cinemaId}&page=${data.page}&pageSize=${data.pageSize}`;

  return axios({
    url: "/api/commercialType/inventoryExport?" + queryString,
    method: "get",
    data: {
      data: {
        isDownladFile: true,
      }
    },
  });
};

export const commercialTypeExport = data => {
  let queryString = `name=${data.name}&cinemaId=${data.cinemaId}&page=${data.page}&pageSize=${data.pageSize}`;

  data.groupIds.forEach(id => {
    queryString = queryString + "&groupIds=" + id;
  });

  return axios({
    url: "/api/commercialType/export?" + queryString,
    method: "get",
    data: {
      data: {
        isDownladFile: true,
      }
    },
  });
};

export const conmmercialTypeDetail = data => {
  let queryString = data.id;
  return axios({
    url: "/api/commercialType/detail/" + queryString,
    method: "get",
    data: { data }
  });
};

export const setCommercialPDFUrl = (data, loading = true,  isDefaultAlertTips = true) => {
  return axios({
    url: `/api/cinema/updateCommercialMenuPdf/${data.cinemaId}?path=${data.path}`,
    method: "put",
    data: {
      loading,
      isDefaultAlertTips
    },
  });
}